import {
  AdviceTemplatesNavIcon,
  CardShieldIcon,
  ClientHubIcon,
  CertificationsNavIcon,
  ChangePasswordNavIcon,
  DashboardSpeed,
  DocStarIcon,
  DocumentStarIcon,
  FinancialPlanningNavIcon,
  FirmProfileNavIcon,
  GoogleDocsIcon,
  HandCashIcon,
  HealthcareIcon,
  HealthShieldIcon,
  LotOfCashIcon,
  ManagePortfolioNavIcon,
  MyProfileNavIcon,
  NotesIcon,
  PasteClipboardIcon,
  PiggyBankIcon,
  PuzzleIcon,
  ReportsIcon,
  RiskAssessmentNavIcon,
  SecureMessagesLinkIcon,
  SendPoundsIcon,
  TaskListIcon,
  UserIcon,
  UserNavIcon,
  WalletIcon,
  WorkingHoursNavIcon,
} from '@zeta-core/assets';
import { RouterLinks } from '../../app-route-paths';

export const DASHBOARD_HEADER = [
  { title: 'Workspace', path: RouterLinks.workspace, icon: TaskListIcon },
  { title: 'Client 360', path: RouterLinks.client360Dashboard, icon: ClientHubIcon },
  { title: 'Plans', path: RouterLinks.clientPlans, icon: FinancialPlanningNavIcon },
  { title: 'Documents', path: RouterLinks.documents, icon: DocStarIcon },
  { title: 'Secure Messages', path: RouterLinks.secureMessageClient, icon: SecureMessagesLinkIcon },
];

export const DASHBOARD_NAVIGATION = [
  {
    title: 'Client Summary',
    path: RouterLinks.factFindInitialMeetingSummary,
    icon: PasteClipboardIcon,
  },
  {
    title: 'Risk Assessment',
    path: RouterLinks.factFindRiskAssessment,
    icon: DashboardSpeed,
  },
  {
    title: 'Personal Information',
    path: RouterLinks.factFindPersonalInfo,
    icon: UserIcon,
  },
  {
    title: 'Income',
    path: RouterLinks.factFindIncome,
    icon: PiggyBankIcon,
  },
  {
    title: 'Expenditure',
    path: RouterLinks.factFindExpenditure,
    icon: WalletIcon,
  },
  {
    title: 'Assets',
    path: RouterLinks.factFindAssets,
    icon: DocumentStarIcon,
  },
  {
    title: 'Liabilities',
    path: RouterLinks.factFindLiabilites,
    icon: SendPoundsIcon,
  },
  {
    title: 'Health Details',
    path: RouterLinks.factFindHealthDetails,
    icon: HealthShieldIcon,
  },
  {
    title: 'Nominees',
    path: RouterLinks.factFindBeneficiaries,
    icon: HandCashIcon,
  },
  {
    title: 'Benefits and Insurance',
    path: RouterLinks.factFindBenefitsAndInsurance,
    icon: HealthcareIcon,
  },
  {
    title: 'Experience',
    path: RouterLinks.factFindExperience,
    icon: GoogleDocsIcon,
  },
  {
    title: 'Financial Planning',
    path: RouterLinks.factFindFinancialPlanning,
    icon: LotOfCashIcon,
  },
  {
    title: 'Protection Solution',
    path: RouterLinks.factFindProtectionSolution,
    icon: CardShieldIcon,
  },
  {
    title: 'Investment Solution',
    path: RouterLinks.factFindInvestmentSolution,
    icon: PuzzleIcon,
  },
  {
    title: 'Summary and Notes',
    path: RouterLinks.factFindSummaryAndNotes,
    icon: NotesIcon,
  },
  {
    title: 'Review',
    path: RouterLinks.factFindReview,
    icon: TaskListIcon,
  },
  {
    title: 'Fact Find Report',
    path: RouterLinks.factFindGenerateReport,
    icon: ReportsIcon,
  },
];

export const FIRM_PROFILE_NAVIGATION = [
  {
    title: `Organisation`,
    icon: FirmProfileNavIcon,
    description: `Manage your firm's details, including address and logo.`,
    path: RouterLinks.organisationProfile,
  },
  {
    title: `User Management`,
    icon: UserNavIcon,
    description: `Add, edit, or remove users and assign roles within your firm.`,
    path: RouterLinks.userManagement,
  },
  {
    title: `Model Portfolios (MPS)`,
    icon: ManagePortfolioNavIcon,
    description: `Control the use of pre-defined investment strategies in portfolio management.`,
    path: RouterLinks.modelPortfolios,
  },
  {
    title: `Risk Assessment`,
    icon: RiskAssessmentNavIcon,
    description: `Choose between standard or custom risk assessment approaches.`,
    path: RouterLinks.riskAssessment,
  },
  {
    title: `Financial Planning`,
    icon: FinancialPlanningNavIcon,
    description: `Access features for comprehensive financial planning and goal setting.`,
    path: RouterLinks.financialPlanning,
  },
  {
    title: `Advice Templates`,
    icon: AdviceTemplatesNavIcon,
    description: `Manage and upload your firm’s document templates for Fact Find and Suitability Reports, as well as other related settings.`,
    path: RouterLinks.adviceTemplates,
  },
];

export const MY_PROFILE_NAVIGATION = [
  {
    title: `My Profile`,
    icon: MyProfileNavIcon,
    description: `Update your personal information and preferences.`,
    path: RouterLinks.myProfile,
  },
  {
    title: `Certifications & Expertise`,
    icon: CertificationsNavIcon,
    description: `Manage your firm’s certifications, expertise, and qualifications to build client trust and ensure compliance.`,
    path: RouterLinks.certificationsAndExpertise,
    hide: true,
  },
  {
    title: `Working Hours`,
    icon: WorkingHoursNavIcon,
    description: `Configure your calendar, including working hours, appointment availability, and holiday schedules.`,
    path: RouterLinks.workingHours,
    hide: true,
  },
  {
    title: `Change Password`,
    icon: ChangePasswordNavIcon,
    description: `You can change your password to ensure your account remains secure.`,
    path: RouterLinks.changePassword,
  },
];

export const DASHBOARD_CONFIG = {
  HEADER: { DESKTOP_HEIGHT: 64 },
  NAVIGATION: { DESKTOP_WIDTH: 312 },
};
